<div class="columns has-background-white">
  <div
    class=" column custom-box p-3"
    *ngIf="(operations$ | async)?.length !== 0; else empty"
  >
    <app-operation-table
      [operations]="operations$ | async"
      (openContent)="openContent($event)"
    ></app-operation-table>
  </div>

  <ng-template #empty>
    <section class="section is-full-width has-text-centered">
      <em class="mdi mdi-48px mdi-alert"></em>
      <div class="weight-medium">
        {{ 'operation-log.no-data' | translate }}
      </div>
    </section>
  </ng-template>
</div>

<app-modal
  [showCloseFooter]="false"
  [isActive]="showModal && selectedOperation"
  (modalState)="showModal = false"
>
  <p class="modal-card-title" modal-title>
    {{
      'operation-log.resume-title.' + selectedOperation?.result?.operationType
        | translate
    }}
  </p>
  <div modal-content>
    <app-operation-content
      [type]="selectedOperation?.result?.operationType"
      [operation]="selectedOperation"
    >
    </app-operation-content>
  </div>
</app-modal>
